import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-pencil p-ml-2" }, null, -1)
const _hoisted_3 = { class: "p-d-flex p-flex-row p-ai-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_InputText = _resolveComponent("InputText")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "p-datatable-sm kn-table p-m-4",
    value: _ctx.parameters,
    editMode: "cell",
    responsiveLayout: "stack",
    breakpoint: "960px",
    onCellEditComplete: _ctx.onCellEditComplete
  }, {
    empty: _withCtx(() => [
      _createVNode("div", null, _toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        field: 'name',
        header: _ctx.$t('common.name'),
        sortable: true
      }, null, 8, ["header"]),
      _createVNode(_component_Column, {
        field: 'value',
        header: _ctx.$t('common.value'),
        sortable: true
      }, {
        editor: _withCtx((slotProps) => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_InputText, {
              class: "kn-material-input p-inputtext-sm",
              modelValue: slotProps.data[slotProps.column.props.field],
              "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _hoisted_2
          ])
        ]),
        body: _withCtx((slotProps) => [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", null, _toDisplayString(slotProps.data[slotProps.column.props.field]), 1)
          ])
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 1
  }, 8, ["value", "onCellEditComplete"]))
}